/**
 * Staff-app tenant chrome. The host maps to DEFAULT_TENANT (usually `l30`).
 * Operators with tenants:list pick another schema; every staff apiFetch
 * sends `X-Tenant-ID` so Atlas, Documents, and Ask Insights share one firm.
 */
export const STAFF_TENANT_STORAGE_KEY = "l30:staff:tenant";
export const STAFF_TENANT_CHANGE_EVENT = "l30:staff:tenant-change";
export const SUBJECT_TRAIL_STORAGE_KEY = "l30:insights:subject-trail";
export const SUBJECT_RECENTS_STORAGE_KEY = "l30:insights:recent-subjects";
const SLUG = /^[a-z0-9-]+$/;
export function isStaffTenantSlug(value) {
    return SLUG.test(value);
}
/**
 * Header to send on staff API calls. Per-request `explicit` wins (portal
 * admin pages that already pass tenantOverride). Otherwise the chrome
 * selection. Null means omit the header and let the host map apply.
 */
export function resolveTenantHeader(explicit, stored) {
    if (explicit && isStaffTenantSlug(explicit))
        return explicit;
    if (stored && isStaffTenantSlug(stored))
        return stored;
    return null;
}
export function readStaffTenantSlug() {
    if (typeof window === "undefined")
        return null;
    return resolveTenantHeader(undefined, window.localStorage.getItem(STAFF_TENANT_STORAGE_KEY));
}
export function writeStaffTenantSlug(slug) {
    if (typeof window === "undefined")
        return;
    if (slug && isStaffTenantSlug(slug)) {
        window.localStorage.setItem(STAFF_TENANT_STORAGE_KEY, slug);
    }
    else {
        window.localStorage.removeItem(STAFF_TENANT_STORAGE_KEY);
    }
    window.dispatchEvent(new Event(STAFF_TENANT_CHANGE_EVENT));
}
export function subscribeStaffTenantChange(listener) {
    if (typeof window === "undefined")
        return () => { };
    window.addEventListener(STAFF_TENANT_CHANGE_EVENT, listener);
    window.addEventListener("storage", listener);
    return () => {
        window.removeEventListener(STAFF_TENANT_CHANGE_EVENT, listener);
        window.removeEventListener("storage", listener);
    };
}
export function clearStaffTenantScopedNavigation() {
    if (typeof window === "undefined")
        return;
    try {
        window.sessionStorage.removeItem(SUBJECT_TRAIL_STORAGE_KEY);
        window.localStorage.removeItem(SUBJECT_RECENTS_STORAGE_KEY);
    }
    catch {
        // Private mode / quota — navigation reset is best-effort.
    }
}
export async function applyStaffTenantSwitch(input) {
    await input.navigateHome();
    clearStaffTenantScopedNavigation();
    input.clearQueryCache();
    writeStaffTenantSlug(input.nextSlug);
}
const LEGACY_TENANT_KEYS = [
    "l30:documents:tenant",
    "l30:portal-admin:tenant",
    "l30:projects:tenant",
    "l30:engagement-plan:tenant",
    "l30:programme-collaboration:tenant",
];
/** One-time copy from page-local Partner dropdowns into the chrome key. */
export function migrateLegacyStaffTenantPrefs() {
    if (typeof window === "undefined")
        return;
    if (readStaffTenantSlug())
        return;
    for (const key of LEGACY_TENANT_KEYS) {
        const raw = window.localStorage.getItem(key);
        if (raw && isStaffTenantSlug(raw)) {
            writeStaffTenantSlug(raw);
            return;
        }
    }
}
//# sourceMappingURL=staff-tenant.js.map